<template>
    <div style="background: #f0f0f0;">
      
        <base-header style="background: rgb(0,205,245);
background: radial-gradient(circle, rgba(0,205,245,1) 25%, rgba(82,227,255,1) 100%);" class="pb-6 pb-8 pt-5 pt-md-8">

          <!-- <h1>{{ hello_world }}</h1> -->
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Starter "
                                type="gradient-blue"
                                v-if="loaded"
                                v-bind:sub-title="subscribers.starter"
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                        <!-- <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{trafficVisits}}</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" >
                    <stats-card title="Silver "
                                type="gradient-gray"
                                v-if="loaded"
                                v-bind:sub-title="subscribers.silver"
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                        <!-- <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{trafficVisits}}</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" >
                    <stats-card title="Gold " 
                                type="gradient-orange"
                                v-if="loaded"
                                v-bind:sub-title="subscribers.gold"
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                       <!--  <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{trafficVisits}}</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Platinum"
                                type="gradient-dark"
                                v-if="loaded"
                                v-bind:sub-title="subscribers.platinum"
                                icon="ni ni-single-02"
                                class="mb-4 mb-xl-0"
                    >

                       <!--  <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i>{{trafficVisits}}</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            </div>
        </base-header>

        <!--Charts-->
         <div class="container-fluid mt--7" v-if="loaded">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card type="default" header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                                <h5 class="h3 text-white mb-0">Visits</h5>
                            </div>
                            <div class="col">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item mr-2 mr-md-0" v-for="store in stores">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === store}"
                                           @click.prevent="initBigChart(store)">
                                            <span class="d-none d-md-block">{{store}}</span>
                                            <span class="d-md-none">{{store}}</span>
                                        </a>
                                    </li>
                                   <!--  <li class="nav-item">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 1}"
                                           @click.prevent="initBigChart(1)">
                                            <span class="d-none d-md-block">Week</span>
                                            <span class="d-md-none">W</span>
                                        </a>
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                        <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart>

                    </card>
                </div>

                <div class="col-xl-4" v-if="loaded">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Retention</h6>
                                <h5 class="h3 mb-0">New vs Recurring (in %)</h5>
                            </div>
                        </div>

                        <pie-chart
                                :height="350"
                                ref="pieChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </pie-chart>
                    </card>
                </div>
            </div>


            <!-- End charts

            <!--Tables-->
           <!--  <div class="row mt-5">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <page-visits-table></page-visits-table>
                </div>
                <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div>
            </div> -->
            <!--End tables-->
        </div> 



           <div class="container-fluid mt-4" v-if="loaded && customerdetentiondata">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                  <card header-classes="bg-transparent">
                    <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                                <h5 class="h3 mb-0">Monthly Customer Retention (in %)</h5>
                            </div>
                        </div>
                    <bar-chart
                            :height="350"
                            ref="barChart"
                            :chart-data="retentionChart.chartData"

                    >
                    </bar-chart>
                  </card>
                </div>

                <!-- <div class="col-xl-4" v-if="loaded">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Retention</h6>
                                <h5 class="h3 mb-0">Customer Retention (Monthly)</h5>
                            </div>
                        </div>

                        <pie-chart
                                :height="350"
                                ref="pieChart"
                                :chart-data="retentionChart.chartData"
                        >
                        </pie-chart>
                    </card>
                </div> -->
            </div>

            
            <!-- End charts

            <!--Tables-->
           <!--  <div class="row mt-5">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <page-visits-table></page-visits-table>
                </div>
                <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div>
            </div> -->
            <!--End tables-->
        </div> 

    </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import PieChart from '@/components/Charts/PieChart';

  // Tables
  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
  import PageVisitsTable from './Dashboard/PageVisitsTable';
  import { mapGetters } from "vuex";
  import store from "@/store";

    import { GET_SUBSCRIBERS_TIERS, GET_VISITS, GET_RECURRING_VS_NEW, GET_CUSTOMER_RETENTION } from "@/store/actions.type";


  export default {
    
    components: {
      LineChart,
      BarChart,
      PageVisitsTable,
      SocialTrafficTable,
      PieChart
    },
    // props : ["hello_world", "test_array"], 
    data() {
      return {
        loaded : false,
        bigLineChart: {
          allData: [
            [52, 20, 10, 30, 15, 40, 20, 60, 60],
            [2, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Recurring', 'New'],
            datasets: [{
                backgroundColor: ["#36a2eb", "#ffce56"],
              data: [],
            }]
          }
        },
        retentionChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

            datasets: [{
              label: 'Retention',
              data: [25, 20, 30, 22, 17, 29]
            }]
          },
          extraOptions: chartConfigs.barChartOptionsGradient,

        }
      };
    },
    

    methods: {
        // getSubscribers() {
        // this.$store.dispatch(GET_SUBSCRIBERS_TIERS)
        // .then(({ data }) => {
        //   this.loaded = true;
        //   console.log(loaded);
        //   // this.$router.push({
        //   //   name: "article",
        //   //   params: { slug: data.article.slug }
        //   // });
        // })
        // .catch(({ response }) => {
        //   this.loaded = false;
        //   console.log("ERROR");
        //   console.log(response);
        //   // this.errors = response.data.errors;
        // });;
        // }
      initBigChart(store) {
        let chartData = {
          datasets: [
            
            {
              label: 'New',
              data: this.visitsdata[store]['visits'].map(a=>a.number),
              borderColor: "#ffce56",
               borderWidth: 5
            },
            {
              label: 'Recurring',
              data: this.visitsdata[store]['recurring_visits'].map(a=>a.number),
              borderWidth: 5,
              borderColor: '#36a2eb'
            }
          ],
          labels: this.visitsdata[store]['visits'].map(a => a._id),
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = store;
      }
    },

      computed: {
        ...mapGetters(["isAuthenticated", "subscribers", "visitsdata", "stores", "newcount", "recurringcount", "customerdetentiondata"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    mounted() {
      Promise.all([
        store.dispatch(GET_SUBSCRIBERS_TIERS),
        store.dispatch(GET_VISITS),
        store.dispatch(GET_RECURRING_VS_NEW),
        store.dispatch(GET_CUSTOMER_RETENTION)
      ]).then(() => {
          this.loaded = true;
          console.log(this.stores);
          console.log(this.visitsdata);
          this.initBigChart(this.stores[0]);
          this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });
        // console.log(this.loaded);
        // this.getSubscribers();
        // console.log(this.loaded);
      
      // this.loaded = false;
      // console.log(this.subscribers);
        
        // this.loaded = false;

      // console.log(data);
      
    }
  };
</script>
<style></style>
